import { createSelector } from 'reselect';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
import { PushSubscriptionState, PushSubscriptions, PwaState } from './types';
import { reduxKey, DEFAULT_PUSH_SUBSCRIPTIONS } from './constants';

function getSlice(state): PwaState {
  return (
    state[reduxKey] ||
    ({
      pushSubscriptionState: PushSubscriptionState.LOADING,
      send: DEFAULT_PUSH_SUBSCRIPTIONS,
      initialized: false,
    } as PwaState)
  );
}

export const getPushSubscriptionState = createSelector(
  getSlice,
  (slice: PwaState) => slice.pushSubscriptionState
);

export const getPushSubscriptions = createSelector(
  getSlice,
  (slice: PwaState): PushSubscriptions => slice.send as PushSubscriptions
);

export const getArePushSubscriptionsInitialized = createSelector(
  getSlice,
  (slice: PwaState) => slice.initialized
);

export const getIsPWABannerHidden = createSelector(
  getSlice,
  (slice: PwaState) => slice.hidePWABanner
);

export const getPWAInstallPrompt = createSelector(
  getSlice,
  (slice: PwaState) => slice.PWAInstallPrompt
);

export const getPushPocEnabled = (state): boolean => flagEnabled(state, 'push_poc');
